function bitTest(num, bit) {
  return ((num >> bit) % 2 !== 0)
}

function bitSet(num, bit) {
  return num | 1 << bit
}

function bitClear(num, bit) {
  return num & ~(1 << bit)
}

function bitToggle(num, bit) {
  return bitTest(num, bit) ? bitClear(num, bit) : bitSet(num, bit)
}

export {
  bitTest,
  bitSet,
  bitClear,
  bitToggle
}
